import { primaryColor } from "assets/jss/material-dashboard-pro-react.jsx";
const CDICListStyle = {	
	
	bgPrimary :{
		background:primaryColor,
		color: "#ffffff",
	}
};

export default CDICListStyle;